"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useSize_1 = __importDefault(require("./useSize"));
var constants_1 = require("../constants");
var useBreakpoint = function () {
    var htmlElement = document.getElementsByTagName('html')[0];
    var width = useSize_1.default(htmlElement).width;
    if (width < constants_1.breakpoints.md)
        return 'sm';
    if (width < constants_1.breakpoints.lg)
        return 'md';
    if (width < constants_1.breakpoints.xl)
        return 'lg';
    return 'xl';
};
exports.default = useBreakpoint;
